import { gql } from 'react-apollo';

export default gql`
  mutation updateSelectedOptionTypes(
    $selectedOptionTypes: String
    $qualifiedPurchaser: String
    $intendInvestingFunds: String
    $benefitInvestor: String
  ) {
    updateSelectedOptionTypes(
      input: {
        selectedOptionTypes: $selectedOptionTypes
        qualifiedPurchaser: $qualifiedPurchaser
        intendInvestingFunds: $intendInvestingFunds
        benefitInvestor: $benefitInvestor
      }
    ) {
      _id
      canViewOffers
      accreditationStatus
      accreditationType
      qualifications
      centeralRegistrationNumber
      institutionalOther
      individualOther
      selectedOptionTypes
      intendInvestingFunds
      benefitInvestor
      benefitInvestorQuestions
      benefitInvestorQuestionsOther
      qualifiedPurchaserQuestion

      qualifiedPurchaser
      qualifiedPurchaseOther
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/updateSelectedOptionTypes.js